import { v7 as uuidv7 } from 'uuid';

export const UniqueIdUtils = {
  getUuidV7(): string {
    return uuidv7();
  },
};
